export default __webpack_public_path__ + "static/media/BAL.9cddbe51.svg";